import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";

interface Props {
  cardTextTitle: string;
  cardImg: string;
  selected: boolean;
  slideNumber: string | number;
  cardText: string;
  current: boolean;
  id: number;
}

const animDuration = "0.9s";
const containerWidth = 471;
const sxStyles = {
  mainContainer: {
    display: "flex",
    height: "295px",
    flexDirection: "row",
    position: "relative",
  },
  numberPresentation: {
    display: "flex",
    flexDirection: "row",
    width: "200px",
    height: "28px",
    alignItems: "flex-end",
    marginBottom: "25px",
  },
  numberLineActive: {
    display: "block",
  },
  numberLine: {
    display: "none",
    width: "165px",
    height: "1px",
    backgroundColor: "white",
  },
  textSectionContainerActive: {
    transform: "translateX(0px)",
    width: "0px",
    opacity: "1",
    marginRight: "300px",
  },
  textSectionContainer: {
    width: "290px",
    height: "210px",
    transition: "all 0.9s ease",
    paddingTop: "10px",
    opacity: "0",
    marginRight: "0",
  },
  textContainer: {
    width: "265px",
    height: "72px",
    paddingRight: { xs: "50px", md: 0 },
  },
  textTitle: {
    color: "white",
    fontFamily: "IBM Plex Sans",
    fontSize: "36px",
    lineHeight: "40px",
    fontWeight: "700",
    textAlign: "left",
    marginBottom: 0,
  },
  textActive: {
    opacity: "1",
    transition: `all ${animDuration} ease`,
  },
  text: {
    color: "white",
    fontFamily: "IBM Plex Sans",
    fontSize: "14px",
    fontWeight: "400",
    textAlign: "left",
    opacity: "0",
    transition: `all ${animDuration} ease`,
    transitionDelay: `${animDuration}`,
    whiteSpace: "wrap",
    textOverflow: "ellipsis",
  },
};

const SlideCard = (props: Props) => {
  const { cardText, cardImg, current, slideNumber, cardTextTitle } = props;

  const textContainerStyles = current
    ? {
        ...sxStyles.textSectionContainer,
        ...sxStyles.textSectionContainerActive,
      }
    : sxStyles.textSectionContainer;

  const numberLineStyles = current
    ? { ...sxStyles.numberLine, ...sxStyles.numberLineActive }
    : sxStyles.numberLine;

  const displayDescriptionStyles = current
    ? { ...sxStyles.text, ...sxStyles.textActive }
    : sxStyles.text;

  const imagewidth = current ? containerWidth : "200";

  return (
    <Grid sx={sxStyles.mainContainer} key={cardTextTitle}>
      <Box sx={{ width: { xs: "120px", md: "auto" } }}>
        <img
          src={cardImg}
          alt={cardTextTitle}
          style={{
            width: `${imagewidth}px`,
            height: "295px",
            marginRight: "40px",
            objectFit: "cover",
            borderRadius: "10px",
            filter: `brightness(${current ? "100%" : "50%"})`,
            transition: `all ${animDuration} ease`,
          }}
        />
      </Box>
      <Stack sx={textContainerStyles}>
        <Grid sx={sxStyles.numberPresentation}>
          <Typography
            sx={{ color: "white", lineHeight: "1rem", fontSize: "24px" }}
          >
            {slideNumber}
          </Typography>
          <Box sx={numberLineStyles} />
        </Grid>
        <Stack sx={sxStyles.textContainer}>
          <Typography sx={sxStyles.textTitle}>{cardTextTitle}</Typography>
          <Typography sx={displayDescriptionStyles}>{cardText}</Typography>
        </Stack>
      </Stack>
    </Grid>
  );
};

export default SlideCard;
